// Paid-traffic landing pages, by town and pest.
//
// Deliberately an EXPLICIT list rather than a URL-parameter template. The old
// /:state/:city/:service route rendered any combination someone typed —
// /florida/miami/alligator-removal returned a 200 — which is a soft-404 farm.
// Only the entries below exist; everything else 404s.
//
// These are noindex by design: they exist to match paid ad copy, not to rank.
// The site's own guides do the organic work.

export const CITIES = {
  madison: {
    slug: "madison",
    name: "Madison",
    state: "CT",
    county: "New Haven",
    image: "https://cdn.searchlegends.com/duck-the-bugs/madison-ct-landmarks.jpg",
    // Honest alt text: this is a composited illustration of real landmarks,
    // not a photograph of a single location.
    imageAlt:
      "Illustration of Madison, Connecticut landmarks — the First Congregational Church steeple above the Madison Green, the Deacon John Grave House, and the Hammonasset shoreline",
  },
};

export const LANDING_PAGES = [
  {
    city: "madison",
    pest: "ticks",
    // Keep this close to the literal ad headline — message match is a direct
    // Quality Score input and comes straight off the cost per click.
    headline: "Tick control in Madison, CT",
    sub: "Tell us what you're dealing with and we'll connect you with a local provider who handles ticks. Takes about a minute.",
    // Local proof. Every line is true, sourced, and not something a franchise
    // landing page is saying.
    facts: [
      "Madison is in New Haven County, which recorded Connecticut's highest nymph Lyme infection rate in the state's 2025 tick surveillance — 32%, against a 25% statewide average.",
      "Nymphs are about the size of a poppy seed and most active from late spring through midsummer, which is why they get missed during tick checks.",
      "Ticks wait along woods edges, stone walls and trail margins — the Hammonasset side of town, not the middle of an open lawn.",
    ],
    source: {
      label: "Connecticut Agricultural Experiment Station, 2025 Statewide Tick Surveillance Results",
      url: "https://portal.ct.gov/-/media/caes/press-room/caes-press-release-tick-surveillance-results-3-23-26.pdf",
    },
  },
];

// Shown on the thank-you screen while they wait for a call back. State
// guidance, not our invention — and free things that work, which is the
// brand's whole position.
export const AFTERCARE = {
  ticks: {
    title: "While you wait — four things that work today",
    items: [
      "Do a full tick check after any time outdoors, not just after hiking. Nymphs are poppy-seed sized and easy to miss.",
      "Wear long sleeves and pants in light, tightly woven fabric — it makes ticks far easier to spot.",
      "Tuck pant legs into socks when you're near woods edges, stone walls or tall grass.",
      "Permethrin-treated clothing both repels and kills ticks. Follow the product label.",
    ],
    note: "Prevention guidance from the Connecticut Agricultural Experiment Station.",
  },
  mosquitoes: {
    title: "While you wait — four things that work today",
    items: [
      "Walk the yard and empty anything holding water: saucers, buckets, tarps, toys, wheelbarrows, clogged gutters.",
      "Level low spots that stay soggy for days after rain — those quietly become breeding grounds.",
      "Trim dense shrubs and keep grass short to remove the humid daytime resting spots.",
      "Put a fan on the patio. Mosquitoes are weak flyers and moving air genuinely keeps them off you.",
    ],
  },
};

export const getCity = (slug) => CITIES[slug] || null;

export const getLandingPage = (pest, city) =>
  LANDING_PAGES.find((p) => p.pest === pest && p.city === city) || null;

// Route list for the prerenderer. These are noindex, but prerendering still
// matters here: landing page speed is a Quality Score factor, and paid traffic
// is the traffic you are paying for.
export const LANDING_PAGE_PATHS = LANDING_PAGES.map((p) => `/lp/${p.pest}/${p.city}`);
